import React from 'react';
import Loading from './Loading';

export default function User({user, exportTracks, getPlaylists, percent}){

    return (
        <div className='card mb-4 mx-auto px-3 py-3 shadow-sm text-center' style={{maxWidth: '400px'}}>
            <img src={user.avatarURL} className='card-img-top' alt={`${user.name} avatar`}/>
            <div className="card-body">
                <h3 className='card-title'><a style={{textDecoration: 'none', color: 'black'}} target="_blank" rel="noopener noreferrer" href={user.url}><i className="fab fa-spotify"></i> {user.name}</a></h3>
                <p className="card-text">Found <strong>{user.tracks}</strong> saved tracks.</p>
                {percent !== 0 
                    ? <Loading loadingText='Exporting...' percent={percent} /> 
                    : <button className='btn btn-primary btn-block btn-lg' onClick={exportTracks}><i className="fas fa-file-download"></i> Export Tracks</button>
                }
            </div>
        </div>
    );
}


